export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  UNKNOWN = 'UNKNOWN'
}

export enum GenderDeterminationMethod {
  SURGICAL_SEXING = 'SS',
  DNA_SEXING = 'DNA',
  VISUALLY_SEXED = 'VS',
  NOT_SEXED = 'NS'
}

export enum BirdStatus {
  AVAILABLE = 'AVAILABLE',
  PAIRED = 'PAIRED',
  /** UI-only / legacy; mapped to AVAILABLE on write if API rejects it */
  BREEDING = 'BREEDING',
  NOT_BREEDING = 'NOT_BREEDING',
  SICK = 'SICK',
  FOR_SALE = 'FOR_SALE',
  /** UI-only / marketplace; mapped toward FOR_SALE on write when needed */
  SOLD = 'SOLD',
  DECEASED = 'DECEASED',
  LOST = 'LOST',
  DONATED = 'DONATED'
}

/** Values accepted by API CreateBirdDto / UpdateBirdDto IsEnum(BirdStatus). */
export const API_BIRD_STATUSES = new Set<string>([
  'AVAILABLE',
  'PAIRED',
  'FOR_SALE',
  'DECEASED',
  'LOST',
  'DONATED',
]);

export function toApiBirdStatus(status: string | undefined): string | undefined {
  if (!status) return status;
  if (API_BIRD_STATUSES.has(status)) return status;
  if (status === 'SOLD') return 'FOR_SALE';
  if (status === 'BREEDING' || status === 'NOT_BREEDING' || status === 'SICK') {
    return 'AVAILABLE';
  }
  return 'AVAILABLE';
}

export enum HealthStatus {
  EXCELLENT = 'EXCELLENT',
  GOOD = 'GOOD',
  FAIR = 'FAIR',
  POOR = 'POOR',
  CRITICAL = 'CRITICAL',
  SICK = 'SICK',
  UNDER_OBSERVATION = 'UNDER_OBSERVATION',
  RECOVERING = 'RECOVERING',
  QUARANTINE = 'QUARANTINE',
  UNKNOWN = 'UNKNOWN'
}

export enum VaccinationStatus {
  UP_TO_DATE = 'UP_TO_DATE',
  OVERDUE = 'OVERDUE',
  PARTIAL = 'PARTIAL',
  NOT_STARTED = 'NOT_STARTED',
  UNKNOWN = 'UNKNOWN'
}

export enum EggStatus {
  LAID = 'LAID',
  INCUBATING = 'INCUBATING',
  HATCHED = 'HATCHED',
  FLEDGED = 'FLEDGED',
  BANDED = 'BANDED',
  NOT_FERTILIZED = 'NOT_FERTILIZED',
  BROKEN = 'BROKEN',
  ABANDONED = 'ABANDONED',
  DEAD_IN_SHELL = 'DEAD_IN_SHELL',
  DEAD_BEFORE_BANDING = 'DEAD_BEFORE_BANDING'
}

export enum ChickRearMethod {
  PARENT_REARED = 'PARENT_REARED',
  HAND_REARED = 'HAND_REARED',
  FOSTER_REARED = 'FOSTER_REARED'
}

export enum IUCNStatus {
  EXTINCT = 'EX',
  EXTINCT_IN_WILD = 'EW',
  CRITICALLY_ENDANGERED = 'CR',
  ENDANGERED = 'EN',
  VULNERABLE = 'VU',
  NEAR_THREATENED = 'NT',
  LEAST_CONCERN = 'LC',
  DATA_DEFICIENT = 'DD',
  NOT_EVALUATED = 'NE'
}

export enum CITESStatus {
  APPENDIX_I = 'I',
  APPENDIX_II = 'II',
  APPENDIX_III = 'III',
  NOT_LISTED = 'NL'
} 